/**
 * Who may press the in-call green "interpreting" button: only the client who
 * placed the P2P call, while it is live and no terp has joined yet. Reading
 * storage (not redux) matches how the in-call invite panel decides role and
 * call context; P2P rooms are recognizable by their minted `p2p-` prefix.
 * The stored call's clientId is the server's calls.client_id (sent on
 * p2p_ringing/accepted/join_room); an interpreter is recorded on it when one
 * joins (recordP2PInterpreterOnCall), which canRequestP2PInterpreter reads.
 */
import { getPersistentItem, getPersistentJson, setPersistentItem } from '../vrs-auth/storage';
export function isP2PCallOriginator() {
    if (getPersistentItem('vrs_user_role') !== 'client') {
        return false;
    }
    const call = getPersistentJson('vrs_active_call');
    const user = getPersistentJson('vrs_user_info');
    return Boolean(call?.clientId
        && call.clientId === user?.id
        && typeof call.roomName === 'string'
        && call.roomName.startsWith('p2p-'));
}
/**
 * The green button's gate (web and native): the originator, until an
 * interpreter is on the call. The queue's Request Interpreter button stays
 * hidden for the originator either way (isP2PCallOriginator).
 */
export function canRequestP2PInterpreter() {
    if (!isP2PCallOriginator()) {
        return false;
    }
    const call = getPersistentJson('vrs_active_call');
    return !call?.interpreterId && !call?.interpreterName;
}
/**
 * Record that an interpreter is on the stored call, so neither the web nor the
 * native button offers another (also after a reload). No-op for another call.
 */
export function recordP2PInterpreterOnCall(callId, interpreterName) {
    const call = getPersistentJson('vrs_active_call');
    if (!callId || !call || call.callId !== callId) {
        return;
    }
    setPersistentItem('vrs_active_call', JSON.stringify({
        ...call,
        interpreterName: interpreterName || call.interpreterName || 'Interpreter'
    }));
}
